import React, { useRef } from 'react'
import { CloudinaryFileInput } from 'lp-components'
import { compose, withProps } from 'recompose'

const CloudinaryCustomizedFileInput = (props) => {
  const { customComponent, ...restProps } = props
  const containerRef = useRef()

  const handleVisibleElementClick = () => {
    if (containerRef.current) {
      const fileInput = containerRef.current.querySelector('input[type="file"]')
      if (fileInput) {
        fileInput.click()
      }
    }
  }

  return (
    <>
      <div
        className="visible-element"
        onClick={handleVisibleElementClick}
        style={{ cursor: 'pointer' }}
      >
        {customComponent}
      </div>
      <div
        ref={containerRef}
        className="hidden-element"
        style={{ display: 'none' }}
      >
        <CloudinaryFileInput {...restProps} />
      </div>
    </>
  )
}

// Override our default one to use other env var names (legacy support) and display text
export default compose(
  withProps(({ uploadPath = '', customComponent }) => {
    const timestamp = Date.now()
    return {
      cloudName: process.env.CLOUDINARY_CLOUD_NAME,
      bucket: `${process.env.CLOUDINARY_CLOUD_BUCKET}${uploadPath}/${timestamp}`,
      customComponent,
    }
  })
)(CloudinaryCustomizedFileInput)
